import {
  UI_COLOR_BORDER_DIVIDER_SOFT,
  UI_COLOR_BORDER_FORM_CARD,
  UI_COLOR_SECONDARY,
  UI_COLOR_SHADOW_DIALOG,
  UI_COLOR_SURFACE_INFO,
  UI_COLOR_TEXT_WARM
} from '../../../constants/uiColors'

export const createUserDialogPaperSx = {
  width: 'calc(100% - 32px) !important',
  maxWidth: '640px !important',
  borderRadius: '8px !important',
  boxShadow: `${UI_COLOR_SHADOW_DIALOG} !important`
}

export const createUserDialogHeaderSx = {
  px: { xs: '20px !important', sm: '24px !important' },
  pt: '20px !important',
  pb: '14px !important'
}

export const createUserDialogTitleSx = {
  fontSize: '18px !important',
  fontWeight: '500 !important',
  lineHeight: '1.3 !important'
}

export const createUserDialogContentSx = {
  borderTop: `1px solid ${UI_COLOR_BORDER_DIVIDER_SOFT} !important`,
  px: { xs: '20px !important', sm: '24px !important' },
  pt: '20px !important',
  pb: '8px !important'
}

export const createUserFormCardSx = {
  mt: 2,
  border: `1px solid ${UI_COLOR_BORDER_FORM_CARD}`,
  borderRadius: '8px',
  px: { xs: 2, sm: 2.5 },
  py: 2.5
}

export const createUserFormGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  columnGap: '16px',
  rowGap: '18px'
}

export const createUserFormGridFullSx = {
  gridColumn: { xs: 'auto', sm: '1 / -1' }
}

export const createUserDialogActionsSx = {
  mt: 2,
  px: { xs: '20px !important', sm: '24px !important' },
  py: '16px !important'
}

export const createUserInfoNoteColors = {
  accentColor: UI_COLOR_SECONDARY,
  backgroundColor: UI_COLOR_SURFACE_INFO,
  textColor: UI_COLOR_TEXT_WARM
}

export const createUserInfoNoteSx = {
  border: 0,
  borderLeft: `4px solid ${UI_COLOR_SECONDARY}`,
  borderRadius: '6px',
  mb: 0,
  px: { xs: 1.5, sm: 1.75 },
  py: 1.25
}

export const createUserInfoNoteMessageSx = {
  color: UI_COLOR_TEXT_WARM,
  flex: 1,
  minWidth: 0,
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.45,
  '& strong': {
    fontWeight: 700
  }
}

export const createUserInfoNoteTitleSx = {
  display: 'none'
}
